// extracted by mini-css-extract-plugin
export var button = "button-module--button--a544a";
export var button__dark = "button-module--button__dark--0fd42";
export var button__full = "button-module--button__full--6b092";
export var button__label = "button-module--button__label--abd20";
export var button__large = "button-module--button__large--3e5dc";
export var button__secondary = "button-module--button__secondary--a6580";
export var button__tertiary = "button-module--button__tertiary--3f16d";
export var spin = "button-module--spin--de165";